<div id="ctnForm">
  <form>
    <div>
      <p>{{'conversion.options' |translate}}</p>
      <div>
        <label for="threeColumn">{{'conversion.options.3to4' | translate}}</label>
        <input checked (change)="this.options = '3to4'" type="radio" name="type" value="3to4" id="threeColumn">

      </div>
      <div>
        <label for="forColumn">{{'conversion.options.4to3' |translate}}</label>
        <input (change)="this.options = '4to3'" type="radio" name="type" value="4to3" id="forColumn">

      </div>
    </div>
    <label for="imgUpload">{{"conversion.options.labelUpload" |translate}}</label>
    <input #fileForm accept="image/png, image/jpeg" type="file"
      (change)="imgUploaded($event.target.files, $event.target.result)" name="imgUpload" />
  </form>
  <canvas [ngStyle]="{display:'none'}" id="canvas" #canvas></canvas>
  <canvas [ngStyle]="{display:'none'}" id="hiddenCanvas" #hiddenCanvas></canvas>
</div>
